/**
 * requiredField
 */

define(
        'requiredField',
        ['jquery', 'lib'],
        function ($, lib) {
            "use strict";

            /**
             * Print a message before unload the tab
             * @returns {string} Message to send if a required input is empty,
             */
            function onBeforeUnload()
            {
                if (!checkRequiredFieldInCurrentModule()) {
                    return MSG_REQUIRED_FIELD_ONBEFOREUNLOAD;
                }
            }

            /**
             * Check if there is a required field empty in this module
             * @returns {Boolean} Returns true if a field required is empty
             */
            function checkRequiredFieldInCurrentModule(moduleName, currentTab)
            {
                var foundRequired = false;
                //Tout d'abord on check les formulaires ouverts sur le module courant
                if (typeof currentTab !== "undefined") {
                    // On fait d'abord un check de tout les formulaires affiché dans
                    // le module courant
                    $('#' + moduleName + '_tab').find('.Seed_Tab').each(function () {
                        var tab = $('#' + this.id.replace('link', 'tab'));
                        if (tab.find('.k-grid').length == 0) {
                            // Si l'onglet courant ne contient pas de liste,
                            // c'est un formulaire.
                            if (!checkRequiredFields(this.id.replace('link_', ''))) {
                                foundRequired = true;
                                return false;
                            }
                        }
                    });
                }

                return !foundRequired;
            }

            /**
             * Verifie les champs requis dans le formulaire courant
             * @param {type} idTab ID de l'onglet à vérifier
             * @returns {Boolean} TRUE si tout va bien | FALSE si au moins un champs
             *  obligatoire est oublié
             */
            function checkRequiredFields(idTab)
            {
                var findEmpty = false;
                var frame;
                if (!lib.empty(idTab)) {
                    frame = $("#tab_" + idTab);
                } else {
                    frame = Seed.Tab.GetFrame();
                }
                //On cherche tout les champs requis dans la frame courante
                frame.find('.requiredField').find('input, select, textarea').each(function () {
                    //Verification si le champ est modifiable
                    if ($(this).attr('readonly') !== 'readonly'
                            && $(this).attr('disabled') !== 'disabled') {
                        //Si la valeur du champ est vide
                        if (lib.empty(lib.trim($(this).val()))) {
                            findEmpty = this;
                            return false;
                        }
                    }
                });

                if (findEmpty !== false) {
                    if (!confirm(MSG_REQUIRED_FIELD)) {
                        //Si l'onglet a supprimer n'est pas l'onglet courant, on renvois dessus
                        if (!lib.empty(idTab)
                                && Seed.Tab.aActive[Seed.Tab.CurrentModule] != idTab) {
                            linkClick($('#link_' + idTab), true);
                        }
                        $(findEmpty).parents('section').scrollIntoView();
                        $(findEmpty).tooltip({
                            title: 'Champ requis'
                            , trigger: 'focus'
                            , container: 'body'
                        });
                        $(findEmpty).focus();
                        return false;
                    }
                }
                return true;
            }

            //    exposed public method
            return {
                onBeforeUnload: onBeforeUnload,
                checkRequiredFieldInCurrentModule: checkRequiredFieldInCurrentModule,
                checkRequiredFields: checkRequiredFields
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
